import { createAction, props } from '@ngrx/store';
import { TranslationData } from '../../interfaces/translation.interface';

export const getDefaultFileTranslation = createAction(
    '[Translation] Get Default File Translation',
    props<{ lang: string }>()
);

export const getDefaultFileTranslationSuccess = createAction(
    '[Translation] Get Default File Translation Success',
    props<{ translation: TranslationData }>()
);

export const getFileTranslation = createAction('[Translation] Get File Translation', props<{ lang: string }>());

export const getFileTranslationSuccess = createAction(
    '[Translation] Get File Translation Success',
    props<{ translation: TranslationData }>()
);
